<template>
    <div>
        <el-row type="flex">
            <el-col
                v-if="!showCreateScheduleView"
                :span="20"
                style="
                    flex: auto;
                    background: #fff;
                    padding: 10px;
                    box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 35%);
                "
            >
                <div v-if="showCalendarView">
                    <el-row type="flex" class="row-bg" justify="end">
                        <el-col>
                            <el-row>
                                <el-col :span="7">
                                    <v-text-field
                                        class="timeline-title"
                                        v-model="selectedSchedule.Description"
                                        :disabled="!isEditable"
                                    ></v-text-field>
                                </el-col>
                                <el-col :span="10" v-if="loading">
                                    <v-progress-circular
                                        :width="5"
                                        color="primary"
                                        indeterminate
                                    ></v-progress-circular>
                                    Progressing. Please wait a moment
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="10">
                            <el-row type="flex" justify="end">
                                <el-col
                                    :span="8"
                                    v-if="!isEditable"
                                    style="margin-right: 40px"
                                >
                                    <v-btn
                                        round
                                        color="orange"
                                        @click="isEditable = !isEditable"
                                        dark
                                    >
                                        {{
                                            $t(
                                                'label.schedule-create.title.edit'
                                            )
                                        }}
                                    </v-btn>
                                </el-col>
                                <el-col
                                    :span="8"
                                    v-if="isEditable"
                                    style="margin-right: 40px"
                                >
                                    <v-btn
                                        round
                                        color="primary"
                                        @click="saveSchedule"
                                        dark
                                    >
                                        {{
                                            $t(
                                                'label.schedule-create.title.done'
                                            )
                                        }}
                                    </v-btn>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
                <FullCalendar
                    ref="globalSchedulesTimeLine"
                    class="timeline-global-schedules"
                    :options="calendarOptions"
                    v-if="showCalendarView"
                ></FullCalendar>
                <div v-if="showCalendarView">
                    <el-row type="flex" class="row-bg" justify="end">
                        <el-col :span="2" style="margin-right: 30px">
                            <v-btn
                                round
                                color="red"
                                @click="deleteSchedule()"
                                dark
                                style="width: 100%; margin: 10px 0"
                            >
                                {{ $t('label.schedule-create.title.delete') }}
                            </v-btn>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
            <el-col v-if="showCreateScheduleView">
                <create-global-scehdule></create-global-scehdule>
            </el-col>
            <el-col
                class="
                    global-schedules-right-panel
                    el-form-card el-form-card--right
                "
                :class="{ 'el-form-card--collapse': collapse }"
            >
                <div class="el-form-card__header">
                    <div
                        class="el-form-card__header-left-icon"
                        @click="collapse = !collapse"
                    >
                        <img
                            class="inline-block mt-2"
                            src="/images/icon/global_schedule.png"
                        />
                    </div>
                    <div class="el-form-card__header-text">
                        {{ $t('title.globalschedule') }}
                    </div>
                    <div
                        class="el-form-card__header-right-icon"
                        style="right: 10px"
                        @click="collapse = !collapse"
                    >
                        <img src="/images/icon/minimize.png" />
                    </div>
                </div>
                <div class="el-form-card__collapse-label">
                    {{ $t('navigation.globalschedule') }}
                </div>
                <div v-if="!showCreateScheduleView">
                    <v-btn
                        round
                        color="primary"
                        @click="createScheduleBtnClick"
                        dark
                        style="margin: 10px 0px 10px 52px"
                    >
                        {{ $t('label.schedule-create.title.create') }}
                    </v-btn>
                </div>
                <div
                    class="
                        form-expanded-content
                        form-expanded-content__form-element
                    "
                    v-if="schedules.length"
                >
                    <div
                        class="router-list-item"
                        v-for="schedule in schedules"
                        :key="schedule.ScheduleTemplateID"
                        :class="{
                            'router-list-item--selected':
                                schedule.ScheduleTemplateID ==
                                selectedSchedule.ScheduleTemplateID,
                        }"
                    >
                        <div
                            class="router-list-item__radio"
                            style="
                                width: 100%;
                                padding-left: 35px;
                                padding-top: 6px;
                            "
                        >
                            <div class="el-radio-list">
                                <v-radio-group v-model="selectedSchedule">
                                    <v-radio
                                        color="success"
                                        :value="schedule"
                                        :label="schedule.Description"
                                        hide-details
                                    >
                                    </v-radio>
                                </v-radio-group>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import interactionPlugin from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateGlobalScheduleVue from './CreateGlobalSchedule.vue'

export default {
    name: 'global-schedule',

    components: {
        FullCalendar,
        'create-global-scehdule': CreateGlobalScheduleVue,
    },

    watch: {
        selectedSchedule: {
            handler: function (selectedSchedule) {
                this.showCreateScheduleView = false

                const updatedResources = selectedSchedule.ScheduleParts.map(
                    (item) => {
                        const start = moment()
                            .startOf('week')
                            .add(item.WeekStart, 'seconds')
                        const end = moment()
                            .startOf('week')
                            .add(item.WeekStop, 'seconds')
                        const startTime = start.format('HH:mm')
                        const endTime = end.format('HH:mm')

                        const resource = {
                            resourceId: start.day() == 0 ? 7 : start.day(),
                            title: `${startTime} - ${endTime}`,
                            start:
                                moment().format('YYYY-MM-DD') + 'T' + startTime,
                            end: moment().format('YYYY-MM-DD') + 'T' + endTime,
                            id: item.SchedulePartTemplateID,
                        }
                        return resource
                    }
                )
                if (updatedResources) {
                    this.showCalendarView = true
                    this.$nextTick(() => {
                        this.$refs.globalSchedulesTimeLine
                            .getApi()
                            .setOption('events', updatedResources)
                    })
                }

                this.isEditable =
                    selectedSchedule.ScheduleParts &&
                    selectedSchedule.ScheduleParts.length == 0
            },
        },

        isEditable: {
            handler: function (isEditable) {
                this.$refs.globalSchedulesTimeLine
                    .getApi()
                    .setOption('editable', isEditable)
            },
        },
    },

    data() {
        const resources = [
            {
                id: '1',
                title: this.$i18n.i18next.t('form.label.days.monday'),
                eventColor: '#6ebd63',
                backgroundColor: '#dedede',
                eventClassNames: 'timeline-schedule-event',
            },
            {
                id: '2',
                title: this.$i18n.i18next.t('form.label.days.tuesday'),
                eventColor: '#6ebd63',
                eventClassNames: 'timeline-schedule-event',
            },
            {
                id: '3',
                title: this.$i18n.i18next.t('form.label.days.wednesday'),
                eventColor: '#6ebd63',
                eventClassNames: 'timeline-schedule-event',
            },
            {
                id: '4',
                title: this.$i18n.i18next.t('form.label.days.thursday'),
                eventColor: '#6ebd63',
                eventClassNames: 'timeline-schedule-event',
            },
            {
                id: '5',
                title: this.$i18n.i18next.t('form.label.days.friday'),
                eventColor: '#6ebd63',
                eventClassNames: 'timeline-schedule-event',
            },
            {
                id: '6',
                title: this.$i18n.i18next.t('form.label.days.saturday'),
                eventColor: '#6ebd63',
                eventClassNames: 'timeline-schedule-event',
            },
            {
                id: '7',
                title: this.$i18n.i18next.t('form.label.days.sunday'),
                eventColor: '#6ebd63',
                eventClassNames: 'timeline-schedule-event',
            },
        ]

        return {
            loading: false,
            collapse: true,
            schedules: [],
            selectedSchedule: {
                ScheduleTemplateID: '',
                Description: '',
                ScheduleParts: [],
            },
            showCreateScheduleView: true,
            calendarOptions: {
                schedulerLicenseKey:
                    'CC-Attribution-NonCommercial-NoDerivatives',
                plugins: [
                    resourceTimelinePlugin,
                    interactionPlugin, // needed for dateClick
                ],
                headerToolbar: {
                    left: '',
                    center: '',
                    right: '',
                },
                initialView: 'resourceTimelineDay',
                editable: false,
                selectable: true,
                selectMirror: true,
                select: this.handleDateSelect,
                eventsSet: this.handleEvents,
                resources,
                events: [],
                slotDuration: '00:30:00',
                slotMinTime: '00:00:00',
                slotMaxTime: '24:00:00',
                slotLabelInterval: { hours: 3 },
                slotLabelFormat: [
                    {
                        hour: 'numeric',
                        minute: '2-digit',
                        hour12: false,
                    },
                ],
                eventAdd: (event) => {
                    if (!this.isEditable) {
                        event.revert()
                    } else {
                        console.log('eventAdd ', event)

                        const end = event.event.end
                        if (end == null) {
                            const date = new Date()
                            date.setHours(23, 59, 59, 0)
                            event.event.setEnd(date)
                            event.event.setProp('title', '00:00 - 24:00')
                        }
                    }
                },
                eventOverlap: () => {
                    return false
                },
                eventDrop: (dropped) => {
                    console.log('dropped ', dropped)
                    if (
                        moment().isSame(moment(dropped.event.start), 'day') &&
                        moment().isSame(moment(dropped.event.end), 'day')
                    ) {
                        $(dropped.el).find('.eventCloseIcon').remove()

                        const startTime = moment(dropped.event.start).format(
                            'HH:mm'
                        )
                        const endTime = moment(dropped.event.end).format(
                            'HH:mm'
                        )
                        const title = `${startTime} - ${endTime}`
                        dropped.event.setProp('title', title)
                    } else {
                        dropped.revert()
                    }
                },
                eventResize: (eventResize) => {
                    console.log('eventResize ', eventResize)
                    $(eventResize.el).find('.eventCloseIcon').remove()

                    if (eventResize.event.end.getMinutes() == 29) {
                        const date = new Date(
                            eventResize.event.end.getTime() + 1 * 60000
                        )
                        eventResize.event.setEnd(date)
                    }

                    const startTime = moment(eventResize.event.start).format(
                        'HH:mm'
                    )
                    const endTime = moment(eventResize.event.end).format(
                        'HH:mm'
                    )
                    const title = `${startTime} - ${endTime}`
                    eventResize.event.setProp('title', title)
                    return
                },
                eventMouseEnter: (info) => {
                    if (!this.isEditable) {
                        $(info.el).css('cursor', 'not-allowed')
                        return
                    } else {
                        $(info.el).css('cursor', 'ew-resize')
                        const btn = document.createElement('span')
                        btn.appendChild(document.createTextNode('x'))
                        btn.style.cursor = 'pointer'
                        btn.style.fontSize = '18px'
                        btn.style.fontWeight = 'bold'
                        btn.style.paddingRight = '10px'
                        btn.className = 'eventCloseIcon'
                        btn.addEventListener('click', () => {
                            this.deleteSchedulePart(info)
                        })
                        $(info.el).append(btn)
                        return
                    }
                },
                eventMouseLeave: (info) => {
                    $(info.el).find('.eventCloseIcon').remove()
                },
                // eventClick: this.deleteSchedulePart,
                resourceAreaHeaderContent: this.$i18n.i18next.t(
                    'form.label.schedules'
                ),
                resourceAreaWidth: '90px',
            },
            isEditable: false,
            slotMinWidth: 35,
            showCalendarView: false,
        }
    },

    created() {
        this.showCreateScheduleView = true
        if (!this.permissions.includes('SCHEDULETEMPLATE_READ')) {
            this.$router.replace({ name: 'dashboard' })
        }
        this.fetchSchedules()

        Events.$on('global-schedule-refresh', async (schedulerId) => {
            this.showCreateScheduleView = false
            await this.fetchSchedules()
            this.selectedSchedule = this.schedules.find(
                (item) => item.ScheduleTemplateID === schedulerId
            )
        })
    },

    computed: {
        ...mapGetters(['permissions', 'selectedContainer']),
    },

    methods: {
        async fetchSchedules() {
            this.loading = true
            const { data } = await this.$http.get(
                `Container/${this.selectedContainer.ContainerID}/ScheduleTemplate`
            )
            this.loading = false

            this.schedules = data

            if (this.schedules.length == 0) {
                this.showCreateScheduleView = true
                this.collapse = true
                this.showCalendarView = false
            } else {
                // this.showCalendarView = true
                this.collapse = false
                // const scheduleTemplateId =
                //     this.selectedSchedule &&
                //     this.selectedSchedule.ScheduleTemplateID
                // const scheduleTemplate = this.schedules.find(
                //     (item) => item.ScheduleTemplateID === scheduleTemplateId
                // )

                // if (scheduleTemplate) {
                //     this.selectedSchedule = scheduleTemplate
                // } else {
                //     this.selectedSchedule = data.length
                //         ? data[0]
                //         : (this.selectedSchedule = {
                //               ScheduleTemplateID: '',
                //               Description: '',
                //               ScheduleParts: [],
                //           })
                // }
            }
        },

        handleDateSelect(selectInfo) {
            const calendarApi = this.$refs.globalSchedulesTimeLine.getApi()
            calendarApi.unselect()

            const startTime = moment(selectInfo.startStr).format('HH:mm')
            const endTime = moment(selectInfo.endStr).format('HH:mm')

            const startStr = moment().format('YYYY-MM-DD') + 'T' + startTime
            const endStr = moment().format('YYYY-MM-DD') + 'T' + endTime

            const event = {
                resourceId: selectInfo.resource.id,
                title: `${startTime} - ${endTime}`,
                start: startStr,
                end: endStr,
                overlap: false,
                id: '',
            }

            var date1 = [moment(selectInfo.startStr), moment(selectInfo.endStr)]
            var range = moment.range(date1)

            const isOverlapped = calendarApi
                .getEvents()
                .filter((event) =>
                    event._def.resourceIds.includes(selectInfo.resource.id)
                )
                .map((event) => {
                    return { start: event.startStr, end: event.endStr }
                })
                .some((comparingData) => {
                    const date2 = [
                        moment(comparingData.start),
                        moment(comparingData.end),
                    ]
                    const range2 = moment.range(date2)
                    return range.overlaps(range2)
                })

            if (!isOverlapped) calendarApi.addEvent(event)
        },

        // handleEvents(events) {
        //     console.log(events)
        // },

        createScheduleBtnClick() {
            this.showCreateScheduleView = true
        },

        async saveSchedule() {
            this.loading = true
            try {
                const events = this.$refs.globalSchedulesTimeLine
                    .getApi()
                    .getEvents()

                await this.updateScheduleTemplateDescription()
                await this.updateScheduleParts(events)

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.updated', {
                        section: 'Schedule',
                    }),
                })
                this.loading = false
                this.isEditable = false
            } catch (e) {
                this.loading = false
                console.error(e)
                if (e === false || e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: `${e.response.data}.`,
                    })
                }
            }
        },

        async deleteSchedule() {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: 'Schedule',
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText:
                            this.$i18n.i18next.t('button.text.cancel'),
                        type: 'warning',
                    }
                )

                this.loading = true
                await this.$http.delete(
                    `/ScheduleTemplate/${this.selectedSchedule.ScheduleTemplateID}`
                )
                // TODO should we delete parts one by one ?
                await this.fetchSchedules()

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.deleted', {
                        section: 'Schedule',
                    }),
                })
                this.loading = false
            } catch (e) {
                this.loading = false
                if (e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },

        async deleteSchedulePart(schedulePart) {
            if (
                schedulePart &&
                schedulePart.event &&
                schedulePart.event.id &&
                this.isEditable
            ) {
                try {
                    await this.$confirm(
                        this.$i18n.i18next.t('message.warning.delete', {
                            section: 'Part',
                        }),
                        'Warning',
                        {
                            confirmButtonText: this.$i18n.i18next.t(
                                'button.text.confirm'
                            ),
                            cancelButtonText:
                                this.$i18n.i18next.t('button.text.cancel'),
                            type: 'warning',
                        }
                    )
                    this.loading = true
                    await this.$http.delete(
                        `/SchedulePartTemplate/${schedulePart.event.id}`
                    )
                    schedulePart.event.remove()
                    await this.fetchSchedules()

                    this.$message({
                        type: 'success',
                        showClose: true,
                        message: this.$i18n.i18next.t(
                            'message.success.deleted',
                            {
                                section: 'Part',
                            }
                        ),
                    })
                    this.loading = false
                } catch (e) {
                    this.loading = false
                    if (e === 'cancel') {
                        //
                    } else {
                        this.$message({
                            type: 'error',
                            showClose: true,
                            message: this.$i18n.i18next.t(
                                'message.error.general'
                            ),
                        })
                    }
                }
            } else if (schedulePart.event) {
                schedulePart.event.remove()
            }
        },

        async updateScheduleTemplateDescription() {
            const { data } = await this.$http.put(
                `/ScheduleTemplate/${this.selectedSchedule.ScheduleTemplateID}`,
                {
                    Description: this.selectedSchedule.Description,
                }
            )
            return data
        },

        async updateScheduleParts(parts) {
            const promises = parts.map(async (part) => {
                let endHour = moment(part.endStr).hour()
                let endMinutes = moment(part.endStr).minute()
                let endSeconds = moment(part.endStr).second()

                const partEndDate = moment(part.endStr).format('HH:mm')
                if (partEndDate == '00:00') {
                    endHour = 23
                    endMinutes = 59
                    endSeconds = 0
                }

                const isExistingPart = part.id !== ''

                const method = isExistingPart ? 'put' : 'post'
                const url = isExistingPart
                    ? `/SchedulePartTemplate/${part.id}`
                    : `/ScheduleTemplate/${this.selectedSchedule.ScheduleTemplateID}/SchedulePartTemplate`
                const day = parseInt(part._def.resourceIds[0])

                const start = moment()
                    .day(day)
                    .hour(moment(part.startStr).hour())
                    .minute(moment(part.startStr).minute())
                    .second(moment(part.startStr).second())
                const end = moment()
                    .day(day)
                    .hour(endHour)
                    .minute(endMinutes)
                    .second(endSeconds)

                var startDuration = start.diff(
                    moment().startOf('week'),
                    'seconds'
                )
                var endDuration = end.diff(moment().startOf('week'), 'seconds')
                const eventPart = {
                    Start: startDuration,
                    Stop: endDuration,
                    ValidFrom: null,
                    ValidTo: null,
                    IsSimpleSchedule: false,
                }
                const { data } = await this.$http[method](url, eventPart)
                return data
            })

            await Promise.all(promises)
        },
    },
}
</script>

<style>
.global-schedules-right-panel {
    width: 250px;
}

.el-form-card--collapse {
    width: 52px;
    cursor: pointer;
}

.timeline-global-schedules {
    height: 355px;
    overflow-x: none;
    overflow-y: none;
}

.timeline-global-schedules table td.fc-datagrid-cell.fc-resource {
    background: #394253;
    color: #fff;
    border-color: #394253;
}

.timeline-global-schedules .fc-datagrid-cell-frame {
    background: #394253;
    color: #fff;
    border-color: #394253;
}

#app
    > div
    > section
    > section
    > section
    > main
    > div.el-main-wrapper
    > div:nth-child(2)
    > div
    > div.el-col.el-col-20
    > div.timeline-global-schedules.fc.fc-media-screen.fc-direction-ltr.fc-theme-standard
    > div.fc-view-harness.fc-view-harness-active
    > div
    > table
    > tbody
    > tr
    > td:nth-child(1)
    > div
    > div {
    background: #394253;
}

.timeline-schedule-event {
    height: 40px;
}

.fc .fc-timeline-overlap-enabled .fc-timeline-lane-frame .fc-timeline-events {
    padding-bottom: 0;
}

.timeline-title input {
    font-size: 30px;
    color: #000000 !important;
    border-bottom: 0px solid #394253;
    -webkit-box-shadow: 0 1px 0 0 #394253;
    -moz-box-shadow: 0 1px 0 0 #394253;
    box-shadow: 0 1px 0 0 #394253;
}

.timeline-title input:focus {
    color: #000000 !important;
    border-bottom: 0px solid #394253;
    -webkit-box-shadow: 0 1px 0 0 #394253;
    -moz-box-shadow: 0 1px 0 0 #394253;
    box-shadow: 0 1px 0 0 #394253;
}
</style>
<style scoped>
.v-text-field input {
    font-size: 30px !important;
}
</style>